const FULL_TEXT_UPLOAD = 'covidence.review.full_text_upload';

export const events = {
  FULL_TEXT_UPLOAD,
};

export const UPLOAD_METHODS = {
  LEGACY_SINGLE_STUDY_MODAL: 'legacy-single-study-modal',
  LEGACY_BULK_UPLOADER: 'legacy-bulk-uploader',
  SINGLE_STUDY_MODAL: 'single-study-modal',
  DRAG_AND_DROP_SCREENING_PAGE: 'drag-and-drop-screening-page',
  BULK_UPLOADER: 'bulk-uploader',
  BULK_UPLOADER_SINGLE_FILE: 'bulk-uploader-single-file',
} as const;

export type UploadMethod = typeof UPLOAD_METHODS[keyof typeof UPLOAD_METHODS];

export const eventProperties = {
  [events.FULL_TEXT_UPLOAD]: { UPLOAD_METHODS },
};

export const sendEvent = (name: string, options: any) => {
  if (typeof window?.pendo?.track !== 'function') {
    if (process.env.DEV) {
      console.group(`Pendo event: ${name}`);
      console.table(options);
      console.groupEnd();
    }
  } else {
    // A throwing third party agent must not break the feature sending the event.
    try {
      window.pendo.track(name, options);
    } catch (error) {
      try {
        if (typeof MetaError !== 'undefined') MetaError.notify(error);
      } catch {
        // notify refers to Sentry, which is undeclared when its script is blocked.
      }
    }
  }
};

export const sendFullTextEvent = ({
  uploadMethod,
  fileCount = 1,
}: {
  uploadMethod: string;
  fileCount?: number;
}) => {
  sendEvent(FULL_TEXT_UPLOAD, {
    full_text_upload_method: uploadMethod,
    total_full_text_uploaded: fileCount,
  });
};
